import React from 'react';
import debounce from 'debounce';
import { Button, Input } from 'antd';

class SupplierSearch extends React.Component {

    render = () => {

        return (
            <div>
                {/* <Select
                    showSearch
                    style={{ width: 200 }}
                    placeholder="Select a company"
                    optionFilterProp="children"
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                
                    {this.state.data.map((d, i) => <Option key={d.key} >{d.text}</Option>)}
                </Select> */}
                <Input placeholder="Company Name or Email" value={ this.state.searchParam } onChange={this.handleChange} />

                <Button disabled={this.state.searchParam.length === 0}
                    onClick={this.handleOnClickCancel}>
                    Cancel
                </Button>
            </div>
        );
    }

    constructor(props) {
        super(props);

        const data = props.suppliers.map( ( supplier, _id ) => {
            const text = supplier.details.companyName,
                  key = supplier._id;
            // return { value, label };
            return {key, text}
        });

        this.updateSupplierFilter = debounce( this.updateSupplierFilter, 700 );

        this.state = {
            data,
            searching: false,
            searchParam: "",
            suppliers: props.suppliers,

        }

    }

    handleOnClickCancel = () => {
        
        this.setState({
            searchParam: ""
        });

        this.props.updateFilter("");
    }
    
    handleChange = ( e ) => {

        this.setState({
            searchParam: e.target.value
        });

        this.updateSupplierFilter();
        // this.setState({
        //     searching: true
        // });

        // const filteredCompany = this.state.suppliers.filter( (supplier) => {
        //     if(supplier._id === value) {
        //         const companyName = supplier.details.companyName;
        //         return companyName;
        //     }
        // })

        // const {companyName} = filteredCompany[0].details;

        // this.props.updateFilter(companyName);
    }

    updateSupplierFilter = () => {
        this.props.updateFilter( this.state.searchParam );
    }

}

export default SupplierSearch;


// WEBPACK FOOTER //
// ./src/components/supplier/search.js